module.exports = require('../dist/components/Text/Text');
